const getSubdomain = () => {
    const hostname = window.location.hostname;
    const subdomain = hostname.split('.')[0];
    return subdomain;
};


export const getDesign = () => {
    switch (getSubdomain()) {
        case 'eurofarma':
            return {
                logos: {
                    login: "/eurofarma/logo_2.png",
                    spinner: "/eurofarma/logo_1.png",
                    header: {
                        browser: "/eurofarma/logo_1.png",
                        mobile: "/eurofarma/logo_2.png"
                    }
                },
                pages: {
                    permission_denied: "/eurofarma/logo_2.png",
                    not_found: "/eurofarma/logo_2.png"
                }
            };
        case 'memory':
            return {
                logos: {
                    login: "/memory/logo_2.png",
                    spinner: "/memory/logo_1.png",
                    header: {
                        browser: "/memory/logo_1.png",
                        mobile: "/memory/logo_2.png"
                    }
                },
                pages: {
                    permission_denied: "/memory/logo_2.png",
                    not_found: "/memory/logo_2.png"
                }
            };
        case 'he':
            return {
                logos: {
                    login: "/he/logo_2.png",
                    spinner: "/he/logo_1.png",
                    header: {
                        browser: "/he/logo_1.png",
                        mobile: "/he/logo_2.png"
                    }
                },
                pages: {
                    permission_denied: "/he/logo_2.png",
                    not_found: "/he/logo_2.png"
                }
            };
        case 'gattazhr':
            return {
                logos: {
                    login: "/gattazhr/logo_2.png",
                    spinner: "/gattazhr/logo_1.png",
                    header: {
                        browser: "/gattazhr/logo_1.png",
                        mobile: "/gattazhr/logo_2.png"
                    }
                },
                pages: {
                    permission_denied: "/gattazhr/logo_2.png",
                    not_found: "/gattazhr/logo_2.png"
                }
            };
        case 'einstein':
            return {
                logos: {
                    login: "/einstein/logo_2.png",
                    spinner: "/einstein/logo_1.png",
                    header: {
                        browser: "/einstein/logo_1.png",
                        mobile: "/einstein/logo_2.png"
                    }
                },
                pages: {
                    permission_denied: "/einstein/logo_2.png",
                    not_found: "/einstein/logo_2.png"
                }
            };
        case 'cujo':
            return {
                logos: {
                    login: "/cujo/logo_2.png",
                    spinner: "/cujo/logo_1.png",
                    header: {
                        browser: "/cujo/logo_1.png",
                        mobile: "/cujo/logo_2.png"
                    }
                },
                pages: {
                    permission_denied: "/cujo/logo_2.png",
                    not_found: "/cujo/logo_2.png"
                }
            };            
        // Default goes to tell
        default:
            return {
                logos: {
                    login: "/tell/logo_login.svg",
                    spinner: "/tell/logo_header_browser.svg",
                    header: {
                        browser: "/tell/logo_header_browser.svg",
                        mobile: "/tell/logo_header_mobile.svg"
                    }
                },
                pages: {
                    permission_denied: "/tell/logo_blue.svg",
                    not_found: "/tell/logo_blue.svg"
                }
            };
    }
};

const loadCSS = (href: string) => {
    const link = document.createElement('link');
    link.id = 'dynamic-css';
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
};


export const applyLabelStyles = () => {
    const subdomain = getSubdomain();
    switch (subdomain) {
        case 'eurofarma':
            loadCSS('/css/eurofarma.css');
            break;
        case 'memory':
            loadCSS('/css/memory.css');
            break;
        case 'he':
            loadCSS('/css/he.css');
            break;
        case 'gattazhr':
            loadCSS('/css/gattazhr.css');
            break;
        case 'einstein':
            loadCSS('/css/einstein.css');
            break;
        case 'cujo':
            loadCSS('/css/cujo.css');
            break;
        default:
            loadCSS('/css/tell.css');
            break;
    }
};